import { cx } from '@hrworks/design-system/functions';

import { S } from './ModalHeader.styles';
import type { ModalHeaderProps } from './ModalHeader.types';

export const ModalHeader = ({ className, ...otherProps }: ModalHeaderProps) => (
  <S.Header className={cx(S.cls.Header, className)} {...otherProps} />
);
